<template lang="pug">
    .animations(ref='animation')
        .checkmates
            svg(width='100%' viewBox='0 0 244 289' preserveAspectRatio='xMidYMid meet')
                g(ref='leg')    
                    path(d='M161.71 190.252C160.409 191.195 161.45 191.78 161.808 192.788C161.938 193.178 162.653 195.291 162.881 195.941C163.401 197.372 163.531 198.932 163.759 200.428C163.922 201.663 163.434 202.996 163.336 204.232C163.239 205.402 163.271 206.605 163.174 207.775C163.044 209.303 162.361 210.571 161.743 211.969C160.864 213.952 159.856 215.48 158.555 217.171C157.775 218.179 138.097 236.125 124.99 236.32C124.827 236.417 122.226 237.1 120.957 237.327C120.176 237.49 119.526 237.75 118.876 238.205C115.883 240.351 112.306 246.235 110.907 247.666C108.76 249.909 101.28 259.727 101.28 259.727C101.02 259.305 100.304 260.117 99.6211 261.06L118.55 272.894C119.721 271.626 120.762 270.423 121.445 269.578C124.437 265.742 125.901 261.58 127.364 259.955C128.958 258.199 133.121 252.803 135.04 251.502C136.634 250.397 143.562 246.658 146.424 243.927C149.221 241.294 157.514 231.28 158.75 229.622C160.832 226.762 164.019 223.966 166.784 221.722C169.451 219.609 173.061 219.382 175.078 216.521C175.956 215.253 176.769 213.757 176.574 212.229C176.216 209.596 173.712 208.263 172.996 205.76C172.476 203.907 172.15 202.021 171.793 200.135C171.175 196.819 168.898 196.007 168.735 195.844C168.573 195.681 168.735 195.064 167.727 194.706C167.564 193.601 166.589 193.471 166.329 193.243C166.654 192.69 165.515 192.235 165.19 192.203C165.028 191.65 164.865 190.675 163.759 190.707C163.629 189.699 162.556 189.667 161.71 190.252Z' fill='#FF0000')
                path(d='M78.741 82.7068L88.9536 55.6255L128.145 17.7832L6.99219 72.5635L78.741 82.7068Z' fill='#000000')
                path(d='M92.238 57.7064L82.7734 83.8449L168.378 100.978L169.288 74.0267L145.741 20.9694L131.658 18.8237L92.238 57.7064Z' fill='#000000')
                path(d='M150.652 21.7168L172.801 73.1811L172.411 101.595L243.672 116.615L150.652 21.7168Z' fill='#000000')
                path(d='M145.805 1.10536L139.951 0L137.544 12.9067L143.398 13.9796L145.805 1.10536Z' fill='#000000')
                path(d='M99.3933 255.598L129.088 96.3287L121.185 94.8657L91.2948 255.208C89.7336 255.175 88.1724 255.143 86.5787 255.143C39.0606 255.143 0.551758 273.902 0.551758 289.344H172.606C172.606 275.299 140.829 258.557 99.3933 255.598Z' fill='#000000')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('bottom-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline.fromTo(this.$refs.leg, {y: 100}, {duration: 1, y: 0}, 0);
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';
.animations {
    width: 100%;
    padding-left: calc(var(--grid-column) * 2);
}
</style>
